import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
import { AssessmentTestAnswerResponse } from './reads';
const PositiveId = z.coerce.number().int().positive();
const SuccessResponse = z.object({ success: z.boolean() });
const AssessmentAnswer = AssessmentTestAnswerResponse;
export const syncAssessmentTestRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/assessments/id/{atCompanyId}/tests/{atTestId}/sync',
    name: 'sync-assessment-test',
    request: {
        params: z.object({ atCompanyId: PositiveId, atTestId: PositiveId }),
        body: z.object({
            testSessionId: PositiveId,
            data: z.object({
                finishedAt: z.string().datetime().nullable(),
                startedAt: z.string().datetime(),
                finishReason: z.enum(['COMPLETED', 'TIME_EXPIRED']).nullable(),
                answers: z.array(AssessmentAnswer),
            }),
        }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const startAssessmentTestRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/assessments/id/{atCompanyId}/tests/{atTestId}/start',
    name: 'start-assessment-test-demo',
    request: {
        params: z.object({ atCompanyId: PositiveId, atTestId: PositiveId }),
        body: z.object({ testSessionId: PositiveId }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const answerAssessmentTestRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/assessments/id/{atCompanyId}/tests/{atTestId}/answer',
    name: 'answer-assessment-test-demo',
    request: {
        params: z.object({ atCompanyId: PositiveId, atTestId: PositiveId }),
        body: z.object({ testSessionId: PositiveId, answer: AssessmentAnswer }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const submitLLMAssessmentTestPromptRoute = {
    version: 1,
    method: 'POST',
    path: '/teams/assessments/id/{atCompanyId}/tests/{atTestId}/llm-playground/submit-prompt',
    name: 'submit-llm-assessment-test-prompt',
    request: {
        params: z.object({ atCompanyId: PositiveId, atTestId: PositiveId }),
        body: z.object({
            testSessionId: PositiveId,
            stepId: z.string().min(1),
            sectionId: z.string().min(1),
            prompt: z.string().min(1),
        }),
    },
    responses: {
        200: SuccessResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
